import { DEFAULT_PRINTER_DISCOVERY_SDKS } from '@packages/shared';
import { createFileRoute } from '@tanstack/react-router';
import { SuperAdminOnly } from '@/features/auth/SuperAdminOnly';
import { usePosConfig } from '@/routes/restaurant/useRestaurantData';
import { DocketTemplates } from './DocketTemplates';
import { PosPrinters } from './PosPrinters';
import { PrinterDiscoverySdks } from './PrinterDiscoverySdks';

export const Route = createFileRoute('/r/$restaurantId/s/pos-printers')({
  component: PosPrintersPage,
});

function PosPrintersPage() {
  const posConfig = usePosConfig();

  if (posConfig === null) return <div>No config yet.</div>;

  return (
    <>
      <PosPrinters posConfig={posConfig} />
      <DocketTemplates posConfig={posConfig} />
      <SuperAdminOnly>
        <PrinterDiscoverySdks
          printerDiscoverySdks={
            posConfig.printerDiscoverySdks ?? [...DEFAULT_PRINTER_DISCOVERY_SDKS]
          }
        />
      </SuperAdminOnly>
    </>
  );
}
